import React, { type FC } from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { ANALYTIC_CONTEXTS } from '@atlassian/jira-servicedesk-common/src/utils/analytics';
import ApplinkErrorPanel, { type Props } from './view';

const AppLinkErrorPanelWithAnalytics: FC<Props> = (props: Props) => (
	<AnalyticsContext
		data={{
			attributes: {
				context: ANALYTIC_CONTEXTS.KNOWLEDGE,
			},
		}}
	>
		<ApplinkErrorPanel {...props} />
	</AnalyticsContext>
);

export default AppLinkErrorPanelWithAnalytics;
